import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import authRepository from "@/repositories/authRepository";
const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  try {
    const res = await authRepository.getUser();
    const currentUser = res.data.data;

    localStorage.setItem("user", JSON.stringify(currentUser));

    if (to.name === "auth" || to.path === "/") {
      return next("/dashboard");
    }

    const allowedRoles = to.meta?.role;
    if (allowedRoles && !allowedRoles.includes(currentUser.role)) {
      return next("/dashboard");
    }

    return next();
  } catch {
    if (to.meta?.public) return next();
    return next("/auth");
  }
});

export default router;
